import { useLocation } from 'react-router'
import ArrowLeftIcon from './ArrowLeftIcon'

const useIsSubRoute = (parentPath: string) => {
  const { pathname } = useLocation()
  return pathname?.startsWith(parentPath) && pathname !== parentPath
}

function Toolbar({
  title = 'Feed',
  arrowColor = '#8fba65',
  titleColor = '#35506d',
  hideArrow = false
}: {
  title: string | undefined
  arrowColor: string | undefined
  titleColor: string | undefined
  hideArrow?: boolean
}) {
  const isFeedPostRoute = useIsSubRoute('/feed/post')

  return (
    <div className="fixed top-0 bg-white py-3 min-h-[55px] w-full text-center border-b border-b-blue-300">
      {!hideArrow && (
        <a
          href="pulsate://backbtn"
          className="absolute left-0 top-0 bottom-0 mt-auto mb-auto py-4 px-3">
          <ArrowLeftIcon color={arrowColor} />
        </a>
      )}
      {!isFeedPostRoute && (
        <h1 style={{ color: titleColor }} className="text-blue-500 text-2xl">
          {title}
        </h1>
      )}
    </div>
  )
}

export default Toolbar
